import { Tab, Tabs, alpha, styled } from "@mui/material";

export const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))(({ theme }) => ({
  backdropFilter: "blur(5px)",
  WebkitBackdropFilter: "blur(5px)",
  backgroundColor: alpha("#FFF", 0.5),
  borderRadius: "20px",
  boxShadow: theme.customShadows.z8,
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    // maxWidth: 80,
    width: "100%",
    backgroundColor: theme.palette.secondary.main,
  },
}));

export const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
    fontSize: "17px",
    fontWeight: 600,
    "&.Mui-selected": {
      color: theme.palette.secondary.main,
      fontWeight: 700,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
    },
  })
);
